import { Config, RouteLoadStrategy } from '@spartacus/core';

import { cmsComponentsConfig } from '../config/configs/cms-components.config';
import { layoutSlotsConfig } from '../config/configs/layout-slots.config';
import { backendConfig } from '../config/configs/backend.config';
import { routesConfig } from '../config/configs/routes.config';

export const spartacusConfig: Config = {
  cmsComponents: cmsComponentsConfig,
  layoutSlots: layoutSlotsConfig,
  backend: backendConfig,
  routing: {
    routes: routesConfig,
    loadStrategy: RouteLoadStrategy.ALWAYS
  },
  enableResetViewOnNavigate: {
    active: false,
    ignoreQueryString: true,
    ignoreRoutes: []
  },
  checkout: {
    guest: true
  },
  context: {
    currency: [],
    language: []
  },
  i18n: {
    fallbackLang: undefined
  },
  features: {
    level: '4.3'
  },
  state: {
    ssrTransfer: {}
  },
  skipLinks: [{
    key: 'cx-header',
    i18nKey: 'skipLink.labels.header'
  }, {
    key: 'cx-main',
    i18nKey: 'skipLink.labels.main'
  }, {
    key: 'cx-footer',
    i18nKey: 'skipLink.labels.footer'
  }],
  pwa: {
    enabled: false
  },
  pageMeta: {
    enableInDevMode: true,
    resolvers: [{
      property: 'canonicalUrl',
      method: 'resolveCanonicalUrl',
      disabledInCsr: false
    }, {
      property: 'title',
      method: 'resolveTitle'
    }, {
      property: 'description',
      method: 'resolveDescription',
      disabledInCsr: false
    }, {
      property: 'image',
      method: 'resolveImage',
      disabledInCsr: false
    }, {
      property: 'robots',
      method: 'resolveRobots',
      disabledInCsr: false
    }],
    canonicalUrl: {
      forceHttps: true,
      forceWww: false,
      removeQueryParams: true,
      forceTrailingSlash: false
    }
  }
};
